import { takeLatest, put, call } from 'redux-saga/effects';
import publicApi from '../../api/public';

import { LOADER_CLOSE, LOADER_OPEN } from '../actions';
import {
  PUBLIC_PAGE_DATA_GET,
  PUBLIC_PAGE_DETAILS_GET,
} from '../actions/public';

function* publicDataGet() {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(publicApi.publicData);
    yield put({ type: PUBLIC_PAGE_DATA_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > publicDataGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* publicDataGetWatch() {
  yield takeLatest(PUBLIC_PAGE_DATA_GET._REQUEST, publicDataGet);
}

function* publicPageGet({ id }) {
  try {
    yield put({ type: LOADER_OPEN });
    const { data: { data: response } = {} } = yield call(
      publicApi.publicPage,
      id
    );
    yield put({ type: PUBLIC_PAGE_DETAILS_GET._SUCCESS, response });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > public > publicPageGet', err);
  } finally {
    yield put({ type: LOADER_CLOSE });
  }
}

function* publicPageGetWatch() {
  yield takeLatest(PUBLIC_PAGE_DETAILS_GET._REQUEST, publicPageGet);
}

export default [publicDataGetWatch(), publicPageGetWatch()];
